import React, { Fragment, useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { AxisDateWithDay } from "../util/AxisDateTime";
import { AvailabilityEditType } from "../components/AvailabilityEditType";
import AvailabilityUserNoteEditor from "../components/AvailabilityUserNoteEditor";

export const AvailabilityDayModal = ({
  visible,
  close,
  date,
  availability = [],
  initialAvailabilityId = null,
  formatAvailabilityLine,
  forceUpdate,
}) => {
  const [selectedAvailability, setSelectedAvailability] = useState(null);

  const sortedAvailability = useMemo(() => {
    return [...availability].sort((a, b) => {
      const surnameCompare = (a?.user?.surname || "").localeCompare(
        b?.user?.surname || "",
      );

      if (surnameCompare !== 0) return surnameCompare;

      return (a?.user?.forename || "").localeCompare(b?.user?.forename || "");
    });
  }, [availability]);

  useEffect(() => {
    if (!visible) {
      setSelectedAvailability(null);
      return;
    }

    setSelectedAvailability((currentSelection) => {
      const initialSelection = sortedAvailability.find(
        (availabilityEntry) => availabilityEntry?.id === initialAvailabilityId,
      );
      if (initialSelection) return initialSelection;

      if (!currentSelection?.id) {
        return sortedAvailability[0] || null;
      }

      return (
        sortedAvailability.find(
          (availabilityEntry) => availabilityEntry?.id === currentSelection.id,
        ) ||
        sortedAvailability[0] ||
        null
      );
    });
  }, [initialAvailabilityId, sortedAvailability, visible]);

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="availability-day-modal"
      centered
      dialogClassName={"availability-day-modal"}
    >
      <Modal.Header closeButton>
        <div>
          <h2 className={"mb-1"}>Availability for {AxisDateWithDay(date)}</h2>
          <div className={"text-axis-gray"}>
            {sortedAvailability.length} user
            {sortedAvailability.length === 1 ? "" : "s"} available
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row className={"g-4"}>
          <Col lg={4}>
            <div className={"availability-day-modal-panel"}>
              <h5 className={"text-axis-offblack mb-3"}>Available Staff</h5>
              <div className={"availability-day-modal-user-list"}>
                {sortedAvailability.map((availabilityEntry) => (
                  <button
                    key={availabilityEntry?.id}
                    type="button"
                    className={
                      "availability-day-modal-user " +
                      (selectedAvailability?.id === availabilityEntry?.id
                        ? "availability-day-modal-user-active"
                        : "")
                    }
                    onClick={() => setSelectedAvailability(availabilityEntry)}
                  >
                    {formatAvailabilityLine(availabilityEntry)}
                  </button>
                ))}
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <Card className={"availability-day-modal-panel"}>
              <Card.Body>
                {selectedAvailability ? (
                  <Fragment>
                    <AvailabilityEditType
                      availabilityObject={selectedAvailability}
                      forceUpdate={forceUpdate}
                      hideModalActions={true}
                    />
                    <AvailabilityUserNoteEditor
                      user={selectedAvailability?.user}
                      onUpdated={forceUpdate}
                    />
                  </Fragment>
                ) : (
                  <div className={"text-axis-gray"}>
                    No user selected for this day.
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
